module.exports = __webpack_public_path__ + "3058b4aff01ddb7e2c52210f369f2b87.svg";